import script from "./StudentPicker.vue?vue&type=script&setup=true&lang=js"
export * from "./StudentPicker.vue?vue&type=script&setup=true&lang=js"

import "./StudentPicker.vue?vue&type=style&index=0&id=39ef556e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-39ef556e"]])

export default __exports__